import React, { FC } from 'react';

import { ReactComponent as JustdoneIconAsset } from '../assets/justdone_icon.svg';
import { ReactComponent as JustdoneLogoAsset } from '../assets/justdone_logo.svg';
import { ReactComponent as JustdoneBigLogoAsset } from '../assets/justdone_logo_big.svg';
import { ReactComponent as LegacyLogoAsset } from '../assets/logo.svg';
import { ReactComponent as LegacyBigLogoAsset } from '../assets/logo_big.svg';

export type JustdoneLogoVariant = 'legacy' | 'new';

type LogoProps = {
  className?: string;
  variant?: JustdoneLogoVariant;
};

type IconProps = {
  className?: string;
};

const getBrandLogoValue = (variant: JustdoneLogoVariant): string => variant;

export const JustdoneLogo: FC<LogoProps> = ({
  variant = 'legacy',
  ...props
}) => {
  const LogoAsset = variant === 'new' ? JustdoneLogoAsset : LegacyLogoAsset;

  return <LogoAsset {...props} data-brand-logo={getBrandLogoValue(variant)} />;
};

export const JustdoneBigLogo: FC<LogoProps> = ({
  variant = 'legacy',
  ...props
}) => {
  const LogoAsset =
    variant === 'new' ? JustdoneBigLogoAsset : LegacyBigLogoAsset;

  return <LogoAsset {...props} data-brand-logo={getBrandLogoValue(variant)} />;
};

export const JustdoneIcon: FC<IconProps> = (props) => {
  return <JustdoneIconAsset {...props} data-brand-logo="new-icon" />;
};
